import { render, staticRenderFns } from "./DeleteNoteBtn.vue?vue&type=template&id=8448a1d4&"
import script from "./DeleteNoteBtn.vue?vue&type=script&lang=ts&"
export * from "./DeleteNoteBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports